module.exports = __webpack_public_path__ + "img/s6Icon2.17f703d5.png";